import resellers from '@/api/resellers';
import statisticApi from '@/api/statistic';

// reseller
const APPEND_NEW_RESELLER = 'APPEND_NEW_RESELLER';
const APPEND_RESELLERS = 'APPEND_RESELLERS';
const SET_RESELLERS = 'SET_RESELLERS';
const RESET_RESELLERS = 'RESET_RESELLERS';
const DELETE_RESELLERS = 'DELETE_RESELLERS';
const BULK_UPDATE_TIER = 'BULK_UPDATE_TIER';
const UPDATED_RESELLER_DATA = 'UPDATED_RESELLER_DATA';
const UPDATED_RESELLER_TIER = 'UPDATED_RESELLER_TIER';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_PAGE = 'SET_PAGE';
const ADD_PAGE = 'ADD_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';
const SET_SUMMARY = 'SET_SUMMARY';
const UPDATE_STATUS = 'UPDATE_STATUS';
const SET_RESELLER_STAT = 'SET_RESELLER_STAT';
const SET_SUMMARY_TOTAL = 'SET_SUMMARY_TOTAL';

const state = {
	all: [],
	isFetching: false,
	isFetched: false,
	isAll: false,
	page: 1,
	detail: '',
	resellerStat: {},
	summary: {
		total: 0,
	},
};

const getters = {
	all: state => state.all,
	isFetching: state => state.isFetching,
	isFetched: state => state.isFetched,
	isAll: state => state.isAll,
	page: state => state.page,
	detail: state => state.detail,
	activitiesFetching: state => state.activitiesFetching,
	activitiesAll: state => state.activitiesAll,
	activitiesIsAll: state => state.activitiesIsAll,
	activitiesPage: state => state.activitiesPage,
	contactStat: state => state.contactStat,
	contactRegionStat: state => state.contactRegionStat,
	remindersAll: state => state.remindersAll,
	isFetchingReminder: state => state.isFetchingReminder,
	isReminderAll: state => state.isReminderAll,
	pageReminder: state => state.pageReminder,
	totalContactReminders: state => state.totalContactReminders,
	tags: state => state.tags,
	products: state => state.products,
	summary: state => state.summary,
	resellerStat: state => state.resellerStat,
};

const mutations = {
	[SET_SUMMARY_TOTAL](state, value) {
		state.summary.total = value;
	},
	[SET_SUMMARY](state, value) {
		state.summary = value;
	},
	// statistic
	[SET_RESELLER_STAT](state, value) {
		state.resellerStat = value;
	},
	[UPDATED_RESELLER_DATA](state, reseller) {
		const resellerIndex = state.all.findIndex(
			curr => curr.source_id === reseller._id,
		);

		if (resellerIndex !== -1) {
			state.all[resellerIndex].name = reseller.name;
			state.all[resellerIndex].email = reseller.email;
			state.all[resellerIndex].phone = reseller.phone;
			state.all[resellerIndex].type = reseller.type;
			state.all[resellerIndex].tier = reseller.reseller.tier;
			// console.log(state.all[resellerIndex].tier);
		}
	},
	[UPDATE_STATUS](state, reseller) {
		console.log('UPDATE_STATUS');
		console.log(reseller);
		const resellerIndex = state.all.findIndex(
			curr => curr._id === reseller._id,
		);

		if (resellerIndex !== -1) {
			state.all[resellerIndex].status = reseller.status;
			// console.log(state.all[resellerIndex].tier);
			state.all.splice(resellerIndex, 1);
		}
	},
	[UPDATED_RESELLER_TIER](state, reseller) {
		const resellerIndex = state.all.findIndex(
			curr => curr._id === reseller._id,
		);

		if (resellerIndex !== -1) {
			state.all[resellerIndex].name = reseller.name;
			state.all[resellerIndex].email = reseller.email;
			state.all[resellerIndex].phone = reseller.phone;
			state.all[resellerIndex].type = reseller.source_type;
			state.all[resellerIndex].tier = reseller.tier;
			// console.log(state.all[resellerIndex].tier);
		}
	},
	[APPEND_RESELLERS](state, resellers) {
		state.all = state.all.concat(resellers);
	},
	[APPEND_NEW_RESELLER](state, reseller) {
		const resellers = state.all;
		console.log('append reseller');
		if (reseller.length === undefined) {
			resellers.unshift(reseller);
			state.all = resellers;
		} else if (reseller.length > 0) {
			reseller = reseller.reverse();
			const filteredRs = reseller.filter(rs => rs.type === 'reseller');
			state.all = [...resellers, ...filteredRs];
		}
	},
	[SET_RESELLERS](state, resellers) {
		state.all = resellers;
	},
	[RESET_RESELLERS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[DELETE_RESELLERS](state, index) {
		state.all.splice(index, 1);
	},
	[BULK_UPDATE_TIER](state, payload) {
		state.all[payload.index].tier = payload.tier;
	},
	[SET_IS_FETCHING](state, status) {
		// console.log(status);
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_PAGE](state, page) {
		state.page = page;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_IS_ALL](state, isAll) {
		state.isAll = isAll;
	},
};

const actions = {
	// statistic
	getStatistic({ commit }, params) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const resellers = response.data;
			commit(SET_RESELLER_STAT, resellers);
			commit(SET_IS_FETCHING, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		statisticApi.getResellerStats(params, callback, errorCallback);
	},
	// cutomers
	updatedResellerData({ commit }, value) {
		if (value.source_type && value.source_type === 'user') {
			commit(UPDATED_RESELLER_TIER, value);
		}
		commit(UPDATED_RESELLER_DATA, value);
	},
	getResellers({ commit, getters }, { params = {}, callback: reqCallback }) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const resellers = response.data;

				if (getters.all.length === 0) {
					// console.log('all');
					commit(SET_RESELLERS, resellers);
				} else if (resellers.length !== 0) {
					// console.log('new');
					commit(APPEND_RESELLERS, resellers);
				}

				if (resellers.length === 0) {
					commit(SET_IS_ALL, true);
				} else {
					commit(SET_IS_ALL, false);
				}

				commit(ADD_PAGE);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
				// add callback
				if (reqCallback) reqCallback();
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_ALL, true);
				commit(SET_IS_FETCHED, true);
			};
			resellers.getResellers(params, callback, errorCallback);
		}
	},
	getSummary({ commit }, params) {
		// console.log('getSummary');
		// if (!getters.isFetching) {
		// commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const summary = response.data;

			commit(SET_SUMMARY, summary);
			// commit(SET_IS_FETCHING, false);
			// if (reqCallback) reqCallback();
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		resellers.getSummary(params, callback, errorCallback);
		// }
	},
	resetResellers({ commit }) {
		commit(RESET_RESELLERS);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setSummaryTotal({ commit }, value) {
		commit(SET_SUMMARY_TOTAL, value);
	},
	setIsAll({ commit }, isAll) {
		commit(SET_IS_ALL, isAll);
	},
	setAppendNewReseller({ commit }, value) {
		commit(APPEND_NEW_RESELLER, value);
	},
	delete({ commit }, index) {
		commit(DELETE_RESELLERS, index);
	},
	bulkUpdateTier({ commit }, payload) {
		commit(BULK_UPDATE_TIER, payload);
	},
	updateStatus({ commit }, payload) {
		commit(UPDATE_STATUS, payload);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
